// extracted by mini-css-extract-plugin
module.exports = {"container":"TA-z","disabled":"UA-z","remove":"VA-z"};